module.exports = __webpack_public_path__ + "static/media/banner-left-asset.d143692a.png";